'use client'
import {
  usePayment
} from "./chunk-QH2UTQBS.mjs";

// src/components/common/PaymentMethods.tsx
import { useMemo } from "react";
import { twMerge } from "tailwind-merge";
import {
  AmericanExpressIcon,
  ApplePayIcon,
  CmiIcon,
  MadaIcon,
  MasterCardIcon,
  StcPayIcon,
  TabbyIcon,
  UnionPayIcon,
  VisaIcon
} from "@wbk/svg";
import { useTranslation } from "@wbk/config";
import { jsx, jsxs } from "react/jsx-runtime";
var PaymentMethods = ({
  className,
  supported = ["mada", "visa", "master_card", "american_express", "cmi", "union_pay"],
  withTabby,
  logosOnly
}) => {
  const { t } = useTranslation("payment_common");
  const { currency, isStcPayEnabled } = usePayment();
  const logos = useMemo(() => {
    const LOGOS = [];
    if (supported.includes("visa")) {
      LOGOS.push(VisaIcon);
    }
    if (supported.includes("mada")) {
      LOGOS.push(MadaIcon);
    }
    if (supported.includes("apple_pay")) {
      LOGOS.push(ApplePayIcon);
    }
    if (supported.includes("master_card")) {
      LOGOS.push(MasterCardIcon);
    }
    if (isStcPayEnabled) {
      LOGOS.push(StcPayIcon);
    }
    if (supported.includes("american_express")) {
      LOGOS.push(AmericanExpressIcon);
    }
    if (currency === "MAD" && supported.includes("cmi")) {
      LOGOS.push(CmiIcon);
    }
    if (withTabby) {
      LOGOS.push(TabbyIcon);
    }
    if (supported.includes("union_pay")) {
      LOGOS.push(UnionPayIcon);
    }
    return LOGOS;
  }, [currency, isStcPayEnabled, supported, withTabby]);
  if (logosOnly) {
    return logos.map((Logo, i) => /* @__PURE__ */ jsx(Logo, { className }, i));
  }
  return /* @__PURE__ */ jsxs("div", { className: twMerge("space-y-1", className), children: [
    /* @__PURE__ */ jsx("p", { className: "text-text-secondary px-2 text-center text-xs", children: t("payment_common:guaranteed_payment") }),
    /* @__PURE__ */ jsx("div", { className: "-mt-2 flex w-full flex-wrap items-center justify-center gap-4 p-1 pb-3 pt-1.5", children: logos.map((Logo, i) => /* @__PURE__ */ jsx(Logo, {}, i)) })
  ] });
};
var PaymentMethods_default = PaymentMethods;

export {
  PaymentMethods_default
};
//# sourceMappingURL=chunk-HRESN6R2.mjs.map